export default __webpack_public_path__ + "static/media/linkedin-logo.a1c679d3.svg";